import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Alert, IconButton } from '@mui/material';
import { Cancel, DeleteForeverOutlined } from '@mui/icons-material';

export default function DeleteButton({onPositive, onNegative, style, buttonText, alertMessage}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
     { !buttonText ? <IconButton style={style} size='small' color='error' variant="outlined" onClick={handleClickOpen}>
        <DeleteForeverOutlined />
      </IconButton> :
      <Button
            variant="outlined"
            color="error"
            style={style}
            startIcon={<DeleteForeverOutlined />}
            onClick={handleClickOpen}
            
        >
            Delete
        </Button>
     } <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete permanently ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Alert severity='error' style={{fontSize:"smaller"}}>
              {alertMessage || "Deleted data cannot be recovered."}
            </Alert>
            Confirm by click Delete button.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
          startIcon={<Cancel/>}
          onClick={()=>{
            onNegative && onNegative()
                handleClose()
            }}>Cancel</Button>
          <Button 
            onClick={()=>{
                onPositive && onPositive()
                handleClose()
            }}
            color="error"
            variant='contained' 
            startIcon={<DeleteForeverOutlined />}
            autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}